'use strict';
import {mapPropsStream} from 'recompose';
import 'rxjs/add/operator/combineLatest';
import {buildDraggable} from '../../../core-utilities/react-utils/Draggable';
import {ProjectLayoutView} from './ProjectLayoutView';


export const StreamedComponent = (props$) => {
  const {
    onDragEnter,
    onDragLeave,
    onDragOver,
    onDrop,
    isDragging$,
  } = buildDraggable(props$);

  return props$
    .combineLatest(
      isDragging$,
      (props, isDragging) => {
        if (props.useDnD) {
          return {
            ...props,
            isDragging,
            onDragEnter,
            onDragLeave,
            onDragOver,
            onDrop,
          };
        } else {
          return props;
        }
      });
};

export const ProjectLayoutComponent = mapPropsStream(StreamedComponent)(ProjectLayoutView);



// WEBPACK FOOTER //
// ./src/js/components/views/ProjectLayout/ProjectLayoutComponent.js